import { AdminRoute } from 'app/route/admin';
import { NavigationNode } from 'model/NavigationNode';
import { compilePath } from 'router/compilePath';

export namespace ProjectTemplateAdminLeftMenuLinks {
  export const projectTemplate = (id: number): NavigationNode[] => [
    {
      label: 'Survey',
      children: [
        {
          label: 'Survey Questions',
          href: compilePath(AdminRoute.Library.SURVEY_PATTERN, { id }),
        },
      ],
    },
  ];
}
